import { AqlExt, Node } from '@anecdotes/api-contracts';

export function evidenceViewFilterResolver(aql: Node<any,any>, extendedAql: AqlExt): {
  filter: any;
  manipulations: any[];
} {
  let res: any = {};

  if (extendedAql?.manipulations?.length) {
    res.filter = extendedAql.filters;
    res.manipulations = extendedAql.manipulations;
  } else {
    res.filter = aql;
    res.manipulations = undefined;
  }

  return res;
}
